exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "td.customers[data-v-6cdebae8]{max-width:200px;white-space:pre-wrap;word-wrap:break-word;overflow:hidden}td.shadow[data-v-6cdebae8]{background:rgba(0,0,0,.025)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cdebae8","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/src/reports/UtilitiesMonitor.vue
// module id = 555
// module chunks = 0